import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { JSX } from "react";
import { appRoutes, AppRoute } from "./routes/routes";
import MainLayout from "./layout/MainLayout";
import { AuthProvider } from "./auth/AuthProvider";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CookieConsentBanner from "./components/cookieConsent/CookieConsentBanner";
import { useCookieConsent } from "./hooks/useCookieConsent";
import ErrorBoundary from "./components/error/ErrorBoundary";

const renderRoutes = (routes: AppRoute[]): JSX.Element[] =>
  routes.map((route, idx) => {
    const key = route.path || `index-${idx}`;

    if (route.index) {
      // Index routes cannot have children
      return <Route key={key} index element={route.element} />;
    }

    return (
      <Route key={key} path={route.path} element={route.element}>
        {route.children && renderRoutes(route.children)}
      </Route>
    );
  });

export default function App() {
  const { preferences, accept, reject, save, reset } = useCookieConsent();

  return (
    <ErrorBoundary>
        <Router>
          <AuthProvider>
            <MainLayout>
              <Routes>{renderRoutes(appRoutes)}</Routes>
            </MainLayout>
          </AuthProvider>
          <ToastContainer
            position="top-right"
            autoClose={4000}
            hideProgressBar
          />
          {preferences === null && (
            <CookieConsentBanner
              current={preferences}
              onAccept={accept}
              onReject={reject}
              onSave={save}
            />
          )}
        </Router>
    </ErrorBoundary>
  );
}
